import { Instance } from 'mobx-state-tree';
import { SyncRouteUpdatedDtoModelBase } from './SyncRouteUpdatedDtoModel.base';

/* The TypeScript type of an instance of SyncRouteUpdatedDtoModel */
export interface SyncRouteUpdatedDtoModelType extends Instance<typeof SyncRouteUpdatedDtoModel.Type> {}

/* A graphql query fragment builders for SyncRouteUpdatedDtoModel */
export { selectFromSyncRouteUpdatedDto, syncRouteUpdatedDtoModelPrimitives, SyncRouteUpdatedDtoModelSelector } from './SyncRouteUpdatedDtoModel.base';

/**
 * SyncRouteUpdatedDtoModel
 */
export const SyncRouteUpdatedDtoModel = SyncRouteUpdatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
